import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { AlertCircle, CheckCircle, X } from 'lucide-react';

function InvoiceToast({ notification, onDismiss }) {
    const { id, message, tone, details } = notification;
    useEffect(() => {
        if (tone === 'red') return undefined;
        const timeout = setTimeout(() => onDismiss(id), 5000);
        return () => clearTimeout(timeout);
    }, [id, tone, onDismiss]);
    const Icon = tone === 'green' ? CheckCircle : AlertCircle;
    return <div className={`esave-notice esave-notice-${tone} esave-toast`}>
        <Icon size={20} aria-hidden="true" />
        <div className="esave-toast-message" role={tone === 'red' ? 'alert' : 'status'} aria-atomic="true">
            <p>{message}</p>
            {details.length > 0 && <details className="esave-toast-details"><summary>Ver detalle · {details.length}</summary>
                <ul>{details.map((detail, index) => <li key={index}>{detail}</li>)}</ul>
            </details>}
        </div>
        <button type="button" className="esave-toast-close" aria-label="Cerrar aviso" onClick={() => onDismiss(id)}><X size={17} aria-hidden="true" /></button>
    </div>;
}

export default function InvoiceNotifications({ notifications, onDismiss }) {
    if (!notifications.length) return null;
    // A portal keeps notifications outside disabled forms and module scroll areas.
    return createPortal(<div className="esave-workspace esave-toast-stack" aria-label="Avisos de facturas">
        {notifications.map(notification => <InvoiceToast key={notification.id} notification={notification} onDismiss={onDismiss} />)}
    </div>, document.body);
}
